import { connect } from "react-redux";
import { IndexRedirect, Route } from "react-router";
import amlClaims, {
  allClaims,
  allClaimsOtherThanAml,
  amlWithDev,
} from "./shared/ClaimLists/Claim.Aml.All.List";
import { UserClaimsAuthenticated } from "./auth/auth.utilities";

import Home from "./states/home/components/Home.Component";
import states from "./routes.states";

import Dashboard from "./states/menu/dashboard/components/Dashboard.Component";
import DashboardOverviewContainer from "./states/menu/dashboard/components/Dashboard.Overview.Component";

import NewLoans from "./states/menu/newLoans/components/NewLoans.Component";

import MenuSettings from "./states/menu/settings/containers/Settings.Container";

import { StatisticsTransactions } from "./states/statistics/components/Statistics.Transactions";
import { StatisticsCurrent } from "./states/statistics/components/Statistics.Current";
import { StatisticsDashboard } from "./states/statistics/components/Statistics.Dashboard";

// User containers

import { User } from "./states/users/components/Users.Component";
import { UserOverview } from "./states/users/components/Users.Overview.Component";
import { ApplicationForUser } from "./states/applications/components/Applications.Component";
import { UserOrdersComponent } from "./states/orders/components/Orders.Component";
import { UserLoansComponent } from "./states/loans/components/Loans.Component";

// Table containers

import CreditSettlement from "./states/creditSettlement/components/Credit.Settlement.Component";
import Transactions, {
  TransactionUserComponent,
} from "./states/transactions/components/Transactions.Component";
import { OrdersComponent } from "./states/orders/components/Orders.Component";
import { LoansComponent } from "./states/loans/components/Loans.Component";
import SpecialAccounts from "./states/specialAccounts/components/SpecialAccounts.Component";
import SsnBlocking from "./scenes/ssnBlock";
// Reports
import TaxReportsComponent from "./states/reports/components/TaxReports.Component";
import UcReportComponent from "./states/reports/components/UCReports.Component";
import CRMReportsComponent from "./states/reports/components/CRMReports.Component";
import MonthlyReportsComponent from "./states/reports/components/MonthlyReports.Component";
import BorrowerDepotSurplus from "./states/reports/components/Borrower.Depot.Surplus.Component";
import ReportsComponent from "./states/reports/components/Reports.Component";

// Other routes
import AccountingComponent from "./states/accounting/components/Accounting.Component";
import AccountingConfirmComponent from "./states/accounting/components/Accounting.Confirm.Component";
import AccountingMatchingComponent from "./states/accounting/components/Accounting.Matching.Component";
import AccountingRegisteringComponent from "./states/accounting/components/Accounting.Registering.Component";
import AccountingRegisteringMarketplaceComponent from "./states/accounting/components/Accounting.Registering.Marketplace.Component";
import AccountingExportComponent from "./states/accounting/components/Accounting.Export.Component";
import AccountingSolvenComponent from "./states/accounting/components/Accounting.Solven.Component";

import AutogiroComponent from "./states/accounting/components/Autogiro/AutogiroPaymentsComponent";
import { Browser } from "./states/browser/components/Browser.Component";
import TermsComponent from "./states/terms/components/Terms.Component";
import Templates from "./states/templates/components/Templates.Component";
import Settings from "./states/settings/components/Settings.Component";

import AmlWarnings from "./states/AML/components/AmlWarnings";
import AmlRules from "./states/AML/components/AmlRules";
import Aml from "./states/AML/components/Aml";
import UserAMLProfile from "./states/users/components/Users.Aml.Profile.Component";
import TwoStepAuthentication from "./states/2step-authentication/components/2step.authentication.component";

// MPL
import MPL from "./states/menu/mpl/components/MPL.Component";
import MPLCreate from "./states/marketplace/components/Marketplace.Component";

//
import RestRepayment from "./states/restRepayments/components/RestRepayment.Page";

import TerminatedSaleLoansComponent from "./states/termintedSaleLoans/components/TerminatedSaleLoansComponent";
import TerminatedCollectionLoansComponent from "./states/terminatedCollectionLoans/components/TerminatedCollectionLoansComponent";
import SellingLoansComponent from "./states/soldLoans/components/Sold.Loans.Component";
import SavelendStuffTab from "./states/LoanstepWithdrawals/components/Savelend.Stuff.Tab.component";
import ReferAFriend from "./states/referAFriend/components/ReferAFriend.Component";
import SavelendMoneyTransactions from "./states/LoanstepWithdrawals/components/Savelend.Money.Transactions.component";
import { Application } from "./states/applications/components/Applications.Component";
import AssignedApplicationsComponent from "./states/applications/components/Assigned.Applications.Component";
import SoldLoansMenuComponent from "./states/menu/soldLoans/Sold.Loans.Menu.Component";
import DCALoansComponent from "./states/soldLoans/components/DCA.Loans.Component";
import PreApplicationsComponent from "./states/applications/components/Pre.Applications.Component";
import ReviewingApplicationsComponent from "./states/applications/components/Reviewing.Applications.Component";
import {
  Financing,
  MPLFinancing,
} from "./states/financing/components/Financing.Component";
import {
  MPLPayout,
  Payouts,
} from "./states/financing/components/Payout.Component";
import AutoInvest from "./states/autoinvest/components/AutoInvest.Component";
import KreditzReports from "./states/applications/components/KreditzReports";
import LoanstepWithdrawalsComponent from "./states/LoanstepWithdrawals/components/Loanstep.Withdraw.Orders.Component";
import { CreditApplication } from "./states/applications/components/Credit.Applications.Component";
import ReviewingCreditApplicationsComponent from "./states/applications/components/Reviewing.Credit.Applications.Component";
import { CreditApplicationForUser } from "./states/applications/components/Personal.Credit.Applications.Component";
import Affiliates from "./states/affiliates/Affiliates.Component";

export default () => {
  return (
    <Route path={states["home"].path} component={Home}>
      <IndexRedirect to={states["dashboard"].path} />
      <Route
        path={states["dashboard"].path}
        component={connectClaimProps({ claimAuth: allClaimsOtherThanAml })(
          UserClaimsAuthenticated(Dashboard),
        )}
      >
        <IndexRedirect to={states["dashboardOverview"].path} />
        <Route
          path={states["dashboardOverview"].path}
          component={DashboardOverviewContainer}
        />
      </Route>
      <Route
        path={states["newLoans"].path}
        component={connectClaimProps({ claimAuth: allClaimsOtherThanAml })(
          UserClaimsAuthenticated(NewLoans),
        )}
      >
        <IndexRedirect to={states["newLoansApplications"].path} />
        <Route
          path={states["newLoansTasks"].path}
          component={AssignedApplicationsComponent}
        />
        <Route
          path={states["newLoansApplications"].path}
          component={Application}
        />
        <Route
          path={states["newCreditApplications"].path}
          component={CreditApplication}
        />
        <Route
          path={states["kreditzReports"].path}
          component={KreditzReports}
        />
        <Route
          path={states["underReviewApplications"].path}
          component={ReviewingApplicationsComponent}
        />
        <Route
          path={states["underReviewCreditApplications"].path}
          component={ReviewingCreditApplicationsComponent}
        />
        <Route
          path={states["preApplications"].path}
          component={PreApplicationsComponent}
        />
        <Route path={states["newLoansPayout"].path} component={Payouts} />
        <Route path={states["autogiro"].path} component={AutogiroComponent} />
        <Route path={states["newLoansLoans"].path} component={LoansComponent} />
        <Route
          path={states["loanstepOrders"].path}
          component={LoanstepWithdrawalsComponent}
        />
        <Route
          path={states["specialAccounts"].path}
          component={SpecialAccounts}
        />
        <Route path={states["ssnBlocking"].path} component={SsnBlocking} />
        <Route
          path={states["restRepaymentLoans"].path}
          component={RestRepayment}
        />
      </Route>
      <Route
        path={states["user"].path}
        component={connectClaimProps({ ClaimAuth: allClaims })(
          UserClaimsAuthenticated(User),
        )}
      >
        <IndexRedirect to={states["userOverview"].path} />
        <Route path={states["userOverview"].path} component={UserOverview} />
        <Route
          path={states["userApplications"].path}
          component={ApplicationForUser}
        />
        <Route
          path={states["userCreditApplications"].path}
          component={CreditApplicationForUser}
        />
        <Route
          path={states["userTransactions"].path}
          component={TransactionUserComponent}
        />
        <Route
          path={states["userOrders"].path}
          component={UserOrdersComponent}
        />
        <Route path={states["userLoans"].path} component={UserLoansComponent} />
        <Route
          path={states["userAMLProfile"].path}
          component={connectClaimProps({ ClaimAuth: amlWithDev })(
            UserClaimsAuthenticated(UserAMLProfile),
          )}
        />
      </Route>
      <Route
        path={states["financing"].path}
        component={connectClaimProps({ claimAuth: allClaimsOtherThanAml })(
          UserClaimsAuthenticated(Financing),
        )}
      />
      <Route
        path={states["applications"].path}
        component={connectClaimProps({ claimAuth: allClaimsOtherThanAml })(
          UserClaimsAuthenticated(Application),
        )}
      />
      <Route
        path={states["transactions"].path}
        component={connectClaimProps({ claimAuth: allClaimsOtherThanAml })(
          UserClaimsAuthenticated(Transactions),
        )}
      />
      <Route
        path={states["credits"].path}
        component={connectClaimProps({ claimAuth: allClaimsOtherThanAml })(
          UserClaimsAuthenticated(Financing),
        )}
      />
      <Route
        path={states["creditSettlement"].path}
        component={connectClaimProps({ claimAuth: allClaimsOtherThanAml })(
          UserClaimsAuthenticated(CreditSettlement),
        )}
      />
      <Route
        path={states["accounting"].path}
        component={connectClaimProps({ claimAuth: allClaimsOtherThanAml })(
          UserClaimsAuthenticated(AccountingComponent),
        )}
      >
        <IndexRedirect to={states["registerPayments"].path} />
        <Route
          path={states["registerPayments"].path}
          component={AccountingRegisteringComponent}
        />
        <Route
          path={states["registerMarketplacePayments"].path}
          component={AccountingRegisteringMarketplaceComponent}
        />
        <Route
          path={states["registerSolvenPayments"].path}
          component={AccountingSolvenComponent}
        />
        <Route
          path={states["matchPayments"].path}
          component={AccountingMatchingComponent}
        >
          <IndexRedirect to={states["matchPaymentsDeposits"].path} />
          <Route
            path={states["matchPaymentsDeposits"].path}
            component={AccountingMatchingComponent}
            tab="deposits"
          />
          <Route
            path={states["matchPaymentsInvoices"].path}
            component={AccountingMatchingComponent}
            tab="invoices"
          />
        </Route>
        <Route
          path={states["confirmPayments"].path}
          component={AccountingConfirmComponent}
        >
          <IndexRedirect to={states["confirmInvestorDeposits"].path} />
          <Route
            path={states["confirmInvestorDeposits"].path}
            component={AccountingMatchingComponent}
            tab="investor-deposits"
          />
          <Route
            path={states["confirmPaymentsInvoices"].path}
            component={AccountingMatchingComponent}
            tab="invoices"
          />
          <Route
            path={states["confirmPaymentsDeposits"].path}
            component={AccountingMatchingComponent}
            tab="deposits"
          />
        </Route>
        <Route
          path={states["exportToFortnox"].path}
          component={AccountingExportComponent}
        />
      </Route>
      <Route
        path={states["menuSettings"].path}
        component={connectClaimProps({ claimAuth: allClaimsOtherThanAml })(
          UserClaimsAuthenticated(MenuSettings),
        )}
      >
        <IndexRedirect to={states["browser"].path} />
        <Route path={states["browser"].path} component={Browser} />
        <Route path={states["autoinvest"].path} component={AutoInvest} />
        <Route path={states["terms"].path} component={TermsComponent} />
        <Route path={states["templates"].path} component={Templates} />
        <Route path={states["settings"].path} component={Settings} />
      </Route>
      <Route
        path={states["mpl"].path}
        component={connectClaimProps({ claimAuth: allClaimsOtherThanAml })(
          UserClaimsAuthenticated(MPL),
        )}
      >
        <IndexRedirect to={states["mplCreate"].path} />
        <Route path={states["mplCreate"].path} component={MPLCreate} />
        <Route path={states["mplFinancing"].path} component={MPLFinancing} />
        <Route path={states["mplPayout"].path} component={MPLPayout} />
      </Route>
      <Route
        path={states["terminatedSale"].path}
        component={connectClaimProps({ claimAuth: allClaimsOtherThanAml })(
          UserClaimsAuthenticated(TerminatedSaleLoansComponent),
        )}
      />
      <Route
        path={states["terminatedCollection"].path}
        component={connectClaimProps({ claimAuth: allClaimsOtherThanAml })(
          UserClaimsAuthenticated(TerminatedCollectionLoansComponent),
        )}
      />
      <Route
        path={states["soldMenu"].path}
        component={connectClaimProps({ claimAuth: allClaimsOtherThanAml })(
          UserClaimsAuthenticated(SoldLoansMenuComponent),
        )}
      >
        <IndexRedirect to={states["sold"].path} />
        <Route path={states["sold"].path} component={SellingLoansComponent} />
        <Route path={states["dca"].path} component={DCALoansComponent} />
      </Route>
      <Route
        path={states["reports"].path}
        component={connectClaimProps({ claimAuth: allClaimsOtherThanAml })(
          UserClaimsAuthenticated(ReportsComponent),
        )}
      >
        <IndexRedirect to={states["ucReports"].path} />
        <Route path={states["ucReports"].path} component={UcReportComponent} />
        <Route
          path={states["crmReports"].path}
          component={CRMReportsComponent}
        />
        <Route
          path={states["taxReports"].path}
          component={TaxReportsComponent}
        />
        <Route
          path={states["monthlyReports"].path}
          component={MonthlyReportsComponent}
        />
        <Route
          path={states["borrowerSurplus"].path}
          component={BorrowerDepotSurplus}
        />
      </Route>
      <Route
        path={states["statistics"].path}
        component={connectClaimProps({ claimAuth: allClaimsOtherThanAml })(
          UserClaimsAuthenticated(StatisticsDashboard),
        )}
      >
        <IndexRedirect to={states["statisticsTransactions"].path} />
        <Route
          path={states["statisticsTransactions"].path}
          component={StatisticsTransactions}
        />
        <Route
          path={states["statisticsCurrent"].path}
          component={StatisticsCurrent}
        />
      </Route>
      <Route
        path={states["aml"].path}
        component={connectClaimProps({ claimAuth: amlClaims })(
          UserClaimsAuthenticated(Aml),
        )}
      >
        <IndexRedirect to={states["amlWarnings"].path} />
        <Route path={states["amlWarnings"].path} component={AmlWarnings} />
        <Route path={states["amlRules"].path} component={AmlRules} />
      </Route>
      <Route path={states["savelendStuff"].path} component={SavelendStuffTab}>
        <IndexRedirect to={states["savelendMoneyTransactions"].path} />
        <Route path={states["orders"].path} component={OrdersComponent} />
        <Route
          path={states["savelendMoneyTransactions"].path}
          component={SavelendMoneyTransactions}
        />
        <Route path={states["referAFriend"].path} component={ReferAFriend} />
        <Route path={states["affiliates"].path} component={Affiliates} />
      </Route>
      <Route
        path={states["twoStepAuth"].path}
        component={connectClaimProps({ claimAuth: amlWithDev })(
          UserClaimsAuthenticated(TwoStepAuthentication),
        )}
      />
    </Route>
  );
};

const connectClaimProps = ({ excludeClaimAuth, claimAuth }) =>
  connect(
    () => {
      return { excludeClaimAuth, claimAuth };
    },
    () => {
      return {};
    },
  );
